import { stateName } from './constants';

const localState = state => state[stateName];

export const getScreenName = state => localState(state).name;